import { JSX } from 'react';
import { AccordionProvider } from './useAccordion';

/**
 * Accordion.
 */
export const Accordion = ({
  children,
  isMulti,
}: {
  children: JSX.Element[] | JSX.Element;
  isMulti?: boolean;
}) => {
  return <AccordionProvider isMulti={isMulti}>{children}</AccordionProvider>;
};
